export default class CreditRequestController {
  constructor(formUpload, $rcAlerts, $window) {
    'ngInject';
    this.$rcAlerts = $rcAlerts;
    this.$window = $window;
    this.formUpload = formUpload;
    this.files = [];
    this.form = {
      sigDate : new Date()
    }
  }
  submit() {
    var ctrl = this;
	var url = '/sps/jas/unsecured/credit-request';
    if (ctrl.formValid.$valid) {
      ctrl.formUpload.uploadFormToUrl(this.form, this.files, url)
      .success(function () {
        ctrl.$rcAlerts.success('Credit Request Submitted!');
        ctrl.$window.scrollTo(0, 0);
        ctrl.reset();
      })
      .error(function () {
        ctrl.$rcAlerts.error('Credit Request Failed!');
        ctrl.$window.scrollTo(0, 0);
      });
    } else {
      ctrl.$rcAlerts.error('Please fill out all required fields');
      ctrl.$window.scrollTo(0, 0);
    }
  }
  addFile() {
    this.files.push(null);
  }
  deleteFile(idx){
    this.files.splice(idx, 1);
  }
  
  reset(){
    this.files = [];
    this.form = {
      sigDate : new Date()
    } 
  }
};



// WEBPACK FOOTER //
// ./src/credit-request/credit-request.controller.js